import store from '../../store';
import SupportView from '../../views/Support/SupportView.vue';

const meta = {
  requiresLogin: true,
  requiresUserType: store.state.User.accountTypes.staff,
};

export const openSupportRoutes = [
  {
    path: '/support/:adminId/ticket/:ticketId',
    name: 'openSupport',
    component: () => import(/* webpackChunkName: "support" */ '../../views/OpenViews/SupportTicketView.vue'),
    props: true,
    meta: {
      requiresLogin: false,
      isOpenView: true,
    },
  },
];

export default [
  {
    path: 'support',
    name: 'support',
    component: SupportView,
    meta,
  },
];
